export { FilterAccordionSection } from './FilterAccordionSection'
export type {
  FilterAccordionIllustration,
  FilterAccordionSectionProps,
} from './FilterAccordionSection'
